import CircleProgressBar from '../../CircularProgressBar';

const FastUseDurationCounter = ({ videoDuration, videoProgress }) => (
  <>
    <CircleProgressBar progress={videoProgress} size={24} strokeWidth={2} />
    <span className="fast-use-player-duration">{videoDuration}</span>
  </>
);

const FastUsePlayerDetail = ({ loading, clicked, videoDuration, videoProgress, title }) => {
  return loading ? null : (
    <>
      {clicked && <div className="fast-use-player-linear-gradiant" />}
      <div className="fast-use-player-title-container">
        <div className="fast-use-player-duration-container">
          <FastUseDurationCounter videoDuration={videoDuration} videoProgress={videoProgress} />
        </div>
        {clicked && <span className="fast-use-player-title">{title}</span>}
      </div>
    </>
  );
};

export default FastUsePlayerDetail;
